import type { ExtractPropTypes, PropType } from 'vue'
import type { RouteLocationNamedRaw } from 'vue-router'

export const authLinkProps = {
  permission: {
    type: [String, Array] as PropType<string | string[]>
  },
  name: {
    type: String as PropType<string>
  },
  to: {
    type: Object as PropType<Omit<RouteLocationNamedRaw, 'name'>>
  },
  blank: {
    type: Boolean,
    default: false
  }
} as const

export type AuthLinkProps = ExtractPropTypes<typeof authLinkProps>
